<div class="sidebar sidebar--edit_search">
	<app-sidebar-header [title]="'editSidebar.title.editSearch' | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="top-gap capitalize">
			<div class="title">
				<h2 class="title-h2">{{ routeType | ibeadmin | async }}</h2>
			</div>
		</div>
		<ul class="edit-content__wrapper">
			<li *ngFor="let route of searchRoutes">{{route.departure? route.departure.location.city : ''}},
				{{route.departure? route.departure.location.country : ''}} —
				{{route.arrival? route.arrival.location.city : ''}}, {{route.arrival? route.arrival.location.country : ''}}
			</li>
			<li *ngIf="stopover.length>0">
				<span class="italic">{{ 'editSidebar.text.withStopover' | ibeadmin | async }}</span>
			</li>
		</ul>
		<div class="top-gap">
			<div class="title">
				<h2 class="title-h2">{{ 'editSidebar.text.passengers' | ibeadmin | async }}</h2>
			</div>
			<ul class="edit-content__wrapper" *ngIf="passengers">
				<li *ngIf="this.passengers.adults>0">
					<span class="bold">{{this.passengers.adults}}</span>
					adult{{this.passengers.adults === 1 ? '' : 's'}}
				</li>
				<li *ngIf="this.passengers.youngAdults>0">
					<span class="bold">{{this.passengers.youngAdults}}</span> young
					adult{{this.passengers.youngAdults === 1 ? '' : 's'}}
				</li>
				<li *ngIf="this.passengers.children>0">
					<span class="bold">{{this.passengers.children}}</span>
					{{this.passengers.children === 1 ? 'child' : 'children'}}
				</li>
				<li *ngIf="this.passengers.infants>0">
					<span class="bold">{{this.passengers.infants}}</span>
					infant{{this.passengers.infants === 1 ? '' : 's'}}
				</li>
			</ul>
		</div>
		<!--
		<div *ngIf="bookingSteps.length > 0 && bookingSteps.length === dates.length">
		-->
		<div *ngIf="bookingSteps.length > 0 && dates.length > 0">
			<div class="top-gap">
				<div class="title">
					<h2 class="title-h2">{{ 'editSidebar.text.dates' | ibeadmin | async }}</h2>
				</div>
				<div class="edit-content__wrapper">
					<ul>
						<li *ngFor="let step of bookingSteps; let index = index">
							<ng-container *ngIf="dates[index]">
								<span class="bold">{{ INDRA_printDate(index, step) }}</span>
								<span> {{ INDRA_printDateLabel(index) }}</span>
							</ng-container>
						</li>
					</ul>
					<ul class="edit-content__wrapper--stopover" [innerHTML]="INDRA_printStopover()"></ul>
				</div>
				<div>
				</div>
				<div class="extras__helper with-notification">
					<a class="link" (click)="INDRA_newSearch()"  
						[attr.aria-label]="'editSidebar.aria.returnToFirstStep' | ibeadmin | async" 
						href="javascript:;" role="button">
						{{ 'editSidebar.text.newSearch' | ibeadmin | async }}
					</a>
				</div>
			</div>
		</div>
		
		<!--
		<div class="info-content__wrapper extras__helper">
			<app-svg svg="icons.svg#general--information" class="info-content__icon" aria-hidden="true" [alt]="'Information icon'"></app-svg>
			<div class="info-content__text">
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pellentesque condimentum auctor. Mauris
				feugiat condimentum malesuada. Aliquam erat volutpat.
			</div>
		</div>
		-->

		<div class="sidebar-flight-text border top-gap">
			<p>
				<a class="link extras-feature__link" [attr.aria-label]="'editSidebar.aria.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()">
					{{ 'editSidebar.text.closeThisWindow' | ibeadmin | async }}
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer ">
	</div>
</div>


<!-- <div class="sidebar sidebar--edit_search">
	<app-sidebar-header [title]="'editSidebar.title.editSearch' | ibeadmin | async"></app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<form class="sidebar__form" [formGroup]="form">
			<div id="trip_radios_row" class="form--edit-mode">
				<div class="form-field--row grid no-padding">
					<div class="col-12 col-tl-12 col-tp-12 col-p-12" id="trip_type_section">
						<app-radio-input-group 
							(optionChanged)="INDRA_selectTripType($event)" 
							[attr.aria-label]="'bookingSearch.aria.selectFlightType' | ibeadmin | async"  
							name="bookType"
							(selected)="INDRA_updateBookTypeOptions($event)"
							[_value]="form.value.routeType" 
							[options]="[{value: 'R', label: 'bookingSearch.label.roundTrip' | ibeadmin | async }, 
								{value: 'O', label: 'bookingSearch.label.oneWay' | ibeadmin | async }, 
								{value: 'M', label: 'bookingSearch.label.multicity' | ibeadmin | async }]"
							[inline]="true">
						</app-radio-input-group>
						<app-book-award-flights></app-book-award-flights>
					</div>
				</div>
			</div>

			<div class="form--view-mode" id="trip-line" *ngIf="!INDRA_isMulticity()">
				<div class="form-field--row grid no-padding"> -->
					<!-- Input "From" -->
					<!-- <div class="form-field col-6 col-tp-6 col-p-12"
						[ngClass]="{'has-error' : INDRA_showError(form.get('from'))}">
						<div class="endpoints-input" aria-label="Select outbound location">
							<app-airport-input [completeOptions]="['seach-region']" [id]="'flight-search-from'" [label]="'bookingSearch.label.whereFrom' | ibeadmin | async" [dataOptions]="origins" [label_filled]="'bookingSearch.label.fromLabel' | ibeadmin | async" formControlName="from"
                                (filterValue)="fromQuery = $event" (selected)="INDRA_selectEndpoint($event, 'from')" (click)="INDRA_setShowAllOptions('from')" (blur)="activeInput='from'" [isLoading]="isOriginLoading" [ariaDescribedby]="'flight-search-from_errdesc'">
                            </app-airport-input>
						</div>
						<span class="large-input__error" *ngIf="INDRA_showError(form.get('from'))"
							id="flight-search-from_errdesc">This field is required</span>
					</div> -->

					<!-- Input "To" -->
					<!-- <div class="form-field col-6 col-tp-6 col-p-12"
						[ngClass]="{'has-error' : INDRA_showError(form.get('to'))}">
						<div class="endpoints-input" aria-label="Select arrival location">
							<app-airport-input [id]="'flight-search-to'" [label]="'bookingSearch.label.whereTo' | ibeadmin | async" [label_filled]="'bookingSearch.label.toLabel' | ibeadmin | async" formControlName="to" [dataOptions]="destinations" (filterValue)="toQuery = $event"
                                (selected)="INDRA_selectEndpoint($event, 'to')" (click)="INDRA_setShowAllOptions('to')" [disabledForm]="INDRA_cantChange()" [instruction]="INDRA_cantChange() ? ('bookingSearch.label.enterDeparture' | ibeadmin | async) : false"
                                (blur)="activeInput='to'" [isLoading]="isDestinationLoading" [ariaDescribedby]="'flight-search-to_errdesc'">
                            </app-airport-input>
						</div>
						<span class="large-input__error" *ngIf="INDRA_showError(form.get('to'))"
							id="flight-search-to_errdesc">This
							field is required</span>
					</div>
				</div>
				<div class="form-field--row grid no-padding col-12 col-tp-12 col-p-12"> -->
					<!-- Input "Date" -->
					<!-- <div class="form-field col-12 col-tp-12 col-p-12">
						<div class="endpoints-input__wrapper endpoints-input__wrapper--datepicker" [ngClass]="{'is-disabled':isClicked}">
							<div class="endpoints-input endpoints-input--datepicker" aria-label="Select flight date"
								[ngClass]="{'is-active': form.controls['dateRange'].value != null || form.controls['dateOne'].value != null}"> -->
								<!-- Round Trip-->
								<!-- <div *ngIf="!INDRA_isOneway()">
									<input type="text" class="form-control" 
										formControlName="dateRange" bsDaterangepicker 
										[bsConfig]="{ containerClass: 'theme-ibe range-calendar', showWeekNumbers: false, selectFromOtherMonth: true, preventChangeToNextMonth: true }" 
										[maxDate]="maxDate" 
										[minDate]="minDate" 
										[bsValue]="bsRangeValue"
										(bsValueChange)="onDateRangeChange($event)">
									<label class="bsdateRangepicker--label">{{ 'bookingSearch.label.when' | ibeadmin | async }}</label>
								</div> -->
								<!-- One way-->
								<!-- <div *ngIf="INDRA_isOneway()">
									<input type="text" class="form-control"
										formControlName="dateOne" bsDatepicker 
										[bsConfig]="{ containerClass: 'theme-ibe one-calendar', showWeekNumbers: false }" 
										[maxDate]="maxDate" 
										[minDate]="minDate" 
										[bsValue]="bsValue" 
										(bsValueChange)="onDateChange($event,0)">
									<label class="bsdatepicker--label">{{ 'bookingSearch.label.when' | ibeadmin | async }}</label>
								</div>

								<div class="iconDatepicker">
									<app-svg svg="icons.svg#general--calendar" [alt]="'Calendar icon'" aria-hidden=true
										aria-label="no price icon"></app-svg>
								</div>
							</div>

							<span class="large-input__error" *ngIf="INDRA_showError(form.controls['dateRange'])"
								[attr.id]="'flight-date-' + index + '_errdesc'">This field is required</span>
							<span class="large-input__error" *ngIf="INDRA_showError(form.controls['dateRange'])"
								[attr.id]="'flight-date-' + index + '_errdesc'">This field is not valid</span>
						</div>
					</div>
				</div>
			</div>

			<ng-container *ngIf="INDRA_isMulticity()">
				<ng-container formArrayName="flights">
					<div class="trip-line" *ngFor="let route of INDRA_getFlightsControl(); let index = index">
						<div>
							<ng-container [formGroupName]="index">
								<div class="form-field--row grid no-padding">
									<div class="form-field col-12 col-tp-12 col-p-12">
										<h5 class="title-h5 flight-title">Flight {{index + 1}}</h5>
									</div>
								</div>
								<div class="form-field--row grid no-padding">
									<div class="form-field col-11 col-tp-11 col-p-12">
										<div class="form-field--row grid no-padding"> -->
											<!-- Input "From" -->
											<!-- <div class="form-field col-6 col-tp-6 col-p-12"
												[ngClass]="{'has-error' : INDRA_showError(route.get('from'))}">
												<div class="endpoints-input" aria-label="Select outbound location">
													<app-airport-input [id]="'flight-search-from-' + index"
														label="Where from?" [completeOptions]="['seach-region']"
														label_filled="From" formControlName="from"
														(filterValue)="fromQuery = $event"
														(selected)="INDRA_selectEndpoint($event, 'from', index)"
														(click)="INDRA_setShowAllOptions('from', index)"
														[ariaDescribedby]="'flight-search-from_errdesc-' + index">
													</app-airport-input>
												</div>
												<span class="large-input__error" *ngIf="INDRA_showError(form.get('from'))" id="flight-search-from_errdesc">
													{{ 'bookingSearch.errorMessage.fieldRequired' | ibeadmin | async }}
												</span>
											</div> -->

											<!-- Input "To" -->
											<!-- <div class="form-field col-6 col-tp-6 col-p-12"
												[ngClass]="{'has-error' : INDRA_showError(route.get('to'))}">
												<div class="endpoints-input" aria-label="Select arrival location">
													<app-airport-input [id]="'flight-search-to-' + index"
														label="Where to?" [completeOptions]="['seach-region']"
														label_filled="To" formControlName="to"
														(filterValue)="toQuery = $event"
														(selected)="INDRA_selectEndpoint($event, 'to', index)"
														(click)="INDRA_setShowAllOptions('to', index)"
														[ariaDescribedby]="'flight-search-to_errdesc-' + index">
													</app-airport-input>
												</div>
												<span class="large-input__error"
													*ngIf="INDRA_showError(route.get('to'))"
													[attr.id]="'flight-search-to_errdesc-' + index">This
													field is required</span>
											</div>
										</div> -->

										<!-- Input "Date" -->
										<!-- <div class="endpoints-input__wrapper endpoints-input__wrapper--datepicker" [ngClass]="{'is-showing-remove': INDRA_getFlightsControl().length > 2, 'has-error':  INDRA_showError(form.get('flights').at(index).get('date'), index)}">
											<div class="endpoints-input endpoints-input--datepicker" [attr.aria-label]="'bookingSearch.aria.selectFlightDate' | ibeadmin | async" [ngClass]="{ 'is-active': INDRA_isActiveDatePicker( index ) }" *ngIf="INDRA_isMulticity()" [attr.aria-hidden]="isMobile">
												<a href="javascript:;" role="button" class="mobile-overlay-click" tabindex="0" (click)="INDRA_openMobileDatepickerModal(index)" [attr.aria-label]="'bookingSearch.aria.openDialogOutbound' | ibeadmin | async"></a>
		
												<my-date-picker tabindex="-1" id="flight-date-{{ index }}" [attr.name]="'flight-date-' + index" formControlName="date" [options]="INDRA_getDatePickerOptions(index)" (inputFocusBlur)="INDRA_onDateChanged($event, index)" (calendarToggle)="INDRA_changeOpenDatepickerIndex($event, index)">
												</my-date-picker>
		
												<label>{{ 'bookingSearch.label.when' | ibeadmin | async }}</label>
											</div>
											<span class="large-input__error" *ngIf="INDRA_showError(form.get('flights').at(index).get('date'), index)">
												{{ 'bookingSearch.errorMessage.fieldRequired' | ibeadmin | async }}
											</span>
											<span class="large-input__error" *ngIf="INDRA_showError(form.get('flights').at(index)) && form.get('flights').at(index).getError('DateFlights')">
												{{ 'bookingSearch.errorMessage.fieldNotValid' | ibeadmin | async }}
											</span>
										</div>
									</div>
									<div class="form-field col-1 col-tp-1 col-p-0">
										<button class="route-close__icon" tabindex="0"
											[attr.aria-label]="'Remove multicity flight ' + (index+1)"
											(click)="INDRA_removeFlight( index )"
											*ngIf="searchRoutes.length > 2">
											<app-svg svg="icons.svg#general--close" class="large-input__icon"
												[alt]="'Remove icon'" aria-hidden="true"></app-svg>
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>
			
			<div class="bottom-gap top-gap" *ngIf="INDRA_isMulticity()">
				<button type="button" *ngIf="!hideAddFlight" class="button--multicity" (click)="INDRA_addMoreFlight()"
					aria-label="Add one more multicity flight">
					<div aria-hidden="true">
						<app-svg class="button--multicity_icon" svg="icons.svg#general--plus" [alt]="'Add flight icon'"
							aria-hidden="true"></app-svg>
						<span class="button--multicity_label">Add one more flight</span>
					</div>
				</button>
			</div>

			<div class="form-field--row grid no-padding" id="passenger_section">
				<div class="form-field no-margin-adjustment col-12 col-tp-12 col-p-12">
					<app-passenger-dropdown [group]="passengers" [isLoading]="loadingPassengers"></app-passenger-dropdown>
				</div>
			</div>
		</form>

		<div class="extras__helper with-notification">
			<a class="link" (click)="INDRA_newSearch()"  
				[attr.aria-label]="'editSidebar.aria.returnToFirstStep' | ibeadmin | async" 
				href="javascript:;" role="button">
				{{ 'editSidebar.text.newSearch' | ibeadmin | async }}
			</a>
		</div>

		<div class="sidebar-flight-text border top-gap">
			<p>
				<a class="link extras-feature__link" [attr.aria-label]="'editSidebar.aria.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()">
					{{ 'editSidebar.text.closeThisWindow' | ibeadmin | async }}
				</a>
			</p>
		</div>
</div> -->
